var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24337",
    "data-name": "Group 24337",
    transform: "translate(-447.501 -1176.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1511",
    "data-name": "Ellipse 1511",
    transform: "translate(447.501 1176.257)",
    fill: "#fff",
    stroke: "#5da9dd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_002-twitter",
    "data-name": "002-twitter",
    d: "M3.3,3.783A5.68,5.68,0,0,0,9.274-1.681q0-.125-.006-.248a4.09,4.09,0,0,0,1.047-.994,4.5,4.5,0,0,1-1.206.3,1.969,1.969,0,0,0,.923-1.062A4.456,4.456,0,0,1,8.7-3.217a2.193,2.193,0,0,0-1.533-.607,2.016,2.016,0,0,0-2.1,1.92,1.763,1.763,0,0,0,.054.438A6.162,6.162,0,0,1,.794-3.472a1.793,1.793,0,0,0-.284.965,1.882,1.882,0,0,0,.934,1.6,2.233,2.233,0,0,1-.951-.24c0,.008,0,.016,0,.025A1.973,1.973,0,0,0,2.177.758a2.292,2.292,0,0,1-.554.068A2.275,2.275,0,0,1,1.229.791,2.087,2.087,0,0,0,3.19,2.125a4.468,4.468,0,0,1-2.608.822,4.667,4.667,0,0,1-.5-.027A6.352,6.352,0,0,0,3.3,3.783",
    transform: "translate(451.303 1185.535)",
    fill: "#5da9dd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.81d7ab3b7c12047181d876901f4402c4.svg";
export { ForwardRef as ReactComponent };